import { CommentFillIcon, InfoIcon, LikeFillIcon } from '@insta-club/components/icons';
import { formatPrice } from '@insta-club/utilities';

interface Props {
    data: {
        avg_comments: number;
        avg_likes: number;
    };
}

const AvgRate = ({ data }: Props) => {
    return (
        <div className='space-y-3'>
            <div className='grid grid-cols-2 gap-4'>
                <div className='shadow-main bg-primary-600 flex flex-col items-center justify-center space-y-1 rounded-md p-4 text-white'>
                    <div className='flex items-center gap-2'>
                        <LikeFillIcon width={20} className='mb-1' />
                        <h5 className='text-base font-medium'>میانگین لایک</h5>
                    </div>
                    <h5 className='text-lg font-semibold'>{formatPrice(data.avg_likes.toString())}</h5>
                </div>
                <div className='shadow-main flex flex-col items-center justify-center space-y-1 rounded-md bg-red-400 p-4 text-white'>
                    <div className='flex items-center gap-2'>
                        <CommentFillIcon width={20} className='mb-1 text-white' />
                        <h5 className='text-base font-medium'>میانگین کامنت</h5>
                    </div>
                    <h5 className='text-lg font-semibold'>{formatPrice(data.avg_comments.toString())}</h5>
                </div>
            </div>
            <div className='flex items-start gap-1'>
                <InfoIcon className='text-gray-600 relative top-0.5 shrink-0'/>
                <p className='text-sm leading-relaxed font-medium text-gray-600'>
                    میانگین لاک و کامنت براساس پست هایی که در بازه این آنالیز منتشر کرده‌اید محاسبه شده است.
                </p>
            </div>
        </div>
    );
};

export default AvgRate;

